import { useTranslation } from 'react-i18next';
import { ReactComponent as SupportBageIcon } from 'src/assets/img/icons/support-bage.svg';
import cls from './SupportBage.module.scss';

const SupportBage = () => {
  const { t: tg } = useTranslation('translation');
  return (
    <a
      className={cls['support-bage']}
      href={'https://t.me/profi_crm'}
      target="_blank"
      rel="noreferrer nofollow"
    >
      <SupportBageIcon />
      <p className={cls['support-bage-title']}>{tg('t-support-bage-title')}</p>
    </a>
  );
};

export default SupportBage;
